import RawlplugWebinars from "./components/RawlplugWebinars.vue";
import * as components from "./components";
import VModal from 'vue-js-modal'
import VueAwesomeSwiper from "vue-awesome-swiper";
import scrollWatch from "vue-scrollwatch";
import Vue from "vue";

export default {
    install(Vue, options = {}) {
        Vue.use(VModal, { componentName: "v-modal" })
        Vue.use(VueAwesomeSwiper);
        Vue.use(scrollWatch)
        Vue.prototype.$WEBINARS = options;
        Vue.component('rawlplug-webinars', RawlplugWebinars)
        Vue.prototype.PUBLIC_PATH = process.env.VUE_APP_ASSETS_URL;

        Object.entries(components).forEach(([componentName, component]) => {
            Vue.component(componentName, component);
        });
    }
}
